import {connect} from 'react-redux';

import {getTimeFormat} from '../../../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {SchedulingLinkRepeatingAvailabilityBlockModel} from '../../../../models/api/schedulingLinkModel';
import {getCalendarWeekStartDay} from '../../../../store/data/preferences/preferencesSelectors';
import {RecurringAvailabilityCalendar} from './recurringAvailabilityCalendar';

/*
 * Props.
 */

interface RecurringAvailabilityCalendarContainerProps {
  selectedSlots: ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel>;
  setSelectedSlots: (arg: ReadonlyArray<SchedulingLinkRepeatingAvailabilityBlockModel>) => void;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<RecurringAvailabilityCalendarContainerProps>()(() => ({
  weekStart: getCalendarWeekStartDay,
  timeFormat: getTimeFormat,
}));

export const RecurringAvailabilityCalendarContainer = connect(mapStateToProps)(RecurringAvailabilityCalendar);
